// extracted by mini-css-extract-plugin
export var linkText = "_py-0";